// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dmn-decision-table-container {
  --allowed-values-placeholder-color: var(--color-grey-225-10-35);
  --cell-description-editor-border-color: var(--color-grey-225-10-15);
  --create-inputs-border-color: var(--color-grey-225-10-75);
  --create-inputs-color: var(--color-grey-225-10-35);
  --create-inputs-hover-color: var(--color-grey-225-10-15);
  --context-menu-background-color: var(--color-white);
  --context-menu-border-color: var(--color-grey-225-10-75);
  --context-menu-color: var(--color-grey-225-10-15);
  --context-menu-box-shadow-color: var(--color-black-opacity-10);
  --context-menu-group-entry-border-color: var(--color-grey-225-10-75);
  --context-menu-group-entry-disabled-color: var(--color-grey-225-10-75);
  --context-menu-group-entry-hover-background-color: var(--color-grey-225-10-95);
  --drag-and-drop-handle-color: var(--color-grey-225-10-55);
  --drag-and-drop-handle-hover-color: var(--color-grey-225-10-15);
  --form-control-label-color: var(--color-grey-225-10-15);
  --hint-color: var(--color-grey-225-10-15);
  --edit-button-color: var(--color-grey-225-10-15);
  --edit-button-background-color: var(--color-grey-225-10-97);
  --edit-button-border-color: var(--color-grey-225-10-75);
  --edit-button-box-shadow-color: var(--color-black-opacity-10);
  --edit-button-disabled-color: var(--color-grey-225-10-75);
}

/* simple string edit */
.dmn-decision-table-container .simple-string-edit,
.dmn-decision-table-container .simple-date-edit {
  width: 250px;
}

.dmn-decision-table-container .input-expression-edit {
  width: 300px;
}

.dmn-decision-table-container .dms-form-control {
  padding: 9px 0;
}

.dmn-decision-table-container .allowed-values-edit .dms-form-control {
  display: flex;
  flex-direction: column;
}

.dmn-decision-table-container .allowed-values-edit .values {
  display: flex;
  flex-wrap: wrap;
}

.dmn-decision-table-container .allowed-values-edit .placeholder {
  color: var(--allowed-values-placeholder-color);
}

/** create inputs **/
.dmn-decision-table-container thead .input-cell.create-inputs,
.dmn-decision-table-container tbody .input-cell.create-inputs {
  white-space: normal;
  border-color: var(--create-inputs-border-color);
  color: var(--create-inputs-color);
  min-width: 50px;
  width: 50px;
}

.dmn-decision-table-container thead .input-cell.create-inputs {
  text-align: center;
}

.dmn-decision-table-container .create-inputs .add-input {
  right: 50%;
}

.dmn-decision-table-container .create-inputs:hover {
  border-color: var(--create-inputs-hover-color);
  color: var(--create-inputs-hover-color);
}

.dmn-decision-table-container th.create-inputs {
  vertical-align: top;
}

/** end create inputs **/

/* TODO(nikku): namespace and refactor context menu styles */
.dmn-decision-table-container .context-menu {
  position: absolute;
  background: var(--context-menu-background-color);
  border: solid 1px var(--context-menu-border-color);
  border-radius: 2px;
  font-size: 14px;
  color: var(--context-menu-color);
  z-index: 6;
  box-shadow: 1px 1px 1px 1px var(--context-menu-box-shadow-color);
}

.dmn-decision-table-container .context-menu .context-menu-container {
  margin: 8px;
}

.dmn-decision-table-container .context-menu .context-menu-flex {
  display: flex;
  flex-direction: column;
}

.dmn-decision-table-container .context-menu .context-menu-group .context-menu-group-entry {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  width: 100%;
  padding: 8px 16px;
  cursor: default;
  white-space: nowrap;
}

.dmn-decision-table-container .context-menu-group .context-menu-group-entry:hover {
  background-color: var(--context-menu-group-entry-hover-background-color);
}

.dmn-decision-table-container .context-menu .context-menu-group .context-menu-group-entry.disabled {
  pointer-events: none;
  color: var(--context-menu-group-entry-disabled-color);
}

.dmn-decision-table-container .context-menu .context-menu-group .context-menu-group-entry .context-menu-group-entry-icon {
  display: inline-block;
  text-align: center;
  width: 14px;
  margin-right: 6px;
}

.dmn-decision-table-container .context-menu .context-menu-group .context-menu-group-entry .context-menu-group-entry-icon::before {
  margin: 0;
}

.dmn-decision-table-container .context-menu-group:not(:last-child)::after {
  content: '';
  display: block;
  margin: 0 8px;
  border-bottom: 1px solid var(--context-menu-group-entry-border-color);
  height: 1px;
}

/* input/output editor */

.dmn-decision-table-container .context-menu .context-menu-container.input-edit,
.dmn-decision-table-container .context-menu .context-menu-container.output-edit {
  margin: 34px 10px 10px;
}

.dmn-decision-table-container .context-menu .context-menu-container.type-ref-edit,
.dmn-decision-table-container .context-menu .context-menu-container.allowed-values-edit {
  margin: 10px;
}

.dmn-decision-table-container .dms-output-label,
.dmn-decision-table-container .dms-input-label {
  padding-right: 30px;
  padding-left: 0;
  border: none;
  font-size: 16px;
  white-space: nowrap;
}

.dmn-decision-table-container .dms-form-control:first-child {
  padding-top: 0;
}

.dmn-decision-table-container .dms-form-control .dms-label {
  display: block;
  margin: unset;
  margin-bottom: 6px;
  color: var(--form-control-label-color);
  font-weight: normal;
}

.dmn-decision-table-container .dms-form-control .dms-input {
  padding-right: 24px;
  border-radius: 3px;
}

.dmn-decision-table-container .dms-form-control .dms-list-component {
  max-width: 179px;
}

/* expression language */
.dmn-decision-table-container .context-menu .context-menu-group .context-menu-entry-set-expression-language {
  flex-direction: column;
}

.dmn-decision-table-container .context-menu .context-menu-group .context-menu-entry-set-expression-language:hover {
  background-color: unset;
}

.dmn-decision-table-container .context-menu .context-menu-group .context-menu-entry-set-expression-language .expression-language {
  margin-top: 8px;
}

/* drag and drop */
.dmn-icon-drag {
  color: transparent;
}

.dmn-icon-drag:hover {
  color: var(--drag-and-drop-handle-hover-color);
}

.dmn-decision-table-container th .dmn-icon-drag {
  position: absolute;
  left: 4px;
  top: 10px;
  transform: translateY(-50%);
}

.dmn-decision-table-container th:hover .dmn-icon-drag,
.dmn-decision-table-container td:hover .dmn-icon-drag {
  color: var(--drag-and-drop-handle-color);
}

.dmn-decision-table-container .input-cell.input-editor:hover .clause,
.dmn-decision-table-container .output-cell.output-editor:hover .clause {
  visibility: hidden;
}

.dmn-icon-drag.horizontal,
.dmn-icon-drag.vertical {
  cursor: grab;
}

/* description editor */

.dmn-decision-table-container .context-menu .description-editor {
  margin: 0;
  padding: 5px 0;
  width: 192px;
  border-left: solid 3px var(--cell-description-editor-border-color);
}

.dmn-decision-table-container .description-editor .dms-input {
  border: none;
  min-height: 0;
}

/* end description editor */

.dmn-decision-table-container .resize-column-handle {
  width: 25px;
  height: 100%;
  position: absolute;
  top: 0;
  right: -5px;
  z-index: 1;
  cursor: col-resize;
}

.dmn-decision-table-container .resize-column-handle:last-child {
  width: 20px;
  right: 0;
}

/* cell editor */
.dmn-decision-table-container .cell-editor:focus-within .dmn-expression-language {
  display: none;
}

.dmn-decision-table-container .cell-editor,
.dmn-decision-table-container .cell-editor .cm-scroller {
  line-height: 1.4;
  font-family: monospace;
}

.dmn-decision-table-container .cell-editor .feel-editor.focussed > :nth-child(2) {
  display: none;
}

/* edit-button */

.dmn-decision-table-container .edit-button {
  color: var(--edit-button-color);
  background-color: var(--edit-button-background-color);
  position: absolute;
  top: 2px;
  left: 2px;
  padding: 4px;
  border-radius: 2px;
  border: solid 1px var(--edit-button-border-color);
  font-size: var(--font-size);
  box-shadow: 1px 1px 1px 1px var(--edit-button-box-shadow-color);
}

.dmn-decision-table-container :not(:has(:focus-visible)) .edit-button {
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}

/* context menu */

.dmn-decision-table-container .context-menu-group-entry.focused {
  background-color: var(--color-grey-225-10-95);
}
`, "",{"version":3,"sources":["webpack://./node_modules/dmn-js/dist/assets/dmn-js-decision-table-controls.css"],"names":[],"mappings":"AAAA;EACE,+DAA+D;EAC/D,mEAAmE;EACnE,yDAAyD;EACzD,kDAAkD;EAClD,wDAAwD;EACxD,mDAAmD;EACnD,wDAAwD;EACxD,iDAAiD;EACjD,8DAA8D;EAC9D,oEAAoE;EACpE,sEAAsE;EACtE,8EAA8E;EAC9E,yDAAyD;EACzD,+DAA+D;EAC/D,uDAAuD;EACvD,yCAAyC;EACzC,gDAAgD;EAChD,2DAA2D;EAC3D,uDAAuD;EACvD,6DAA6D;EAC7D,yDAAyD;AAC3D;;AAEA,uBAAuB;AACvB;;EAEE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,8CAA8C;AAChD;;AAEA,oBAAoB;AACpB;;EAEE,mBAAmB;EACnB,+CAA+C;EAC/C,iCAAiC;EACjC,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8CAA8C;EAC9C,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wBAAwB;;AAExB,4DAA4D;AAC5D;EACE,kBAAkB;EAClB,gDAAgD;EAChD,kDAAkD;EAClD,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,UAAU;EACV,gEAAgE;AAClE;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,wEAAwE;AAC1E;;AAEA;EACE,oBAAoB;EACpB,qDAAqD;AACvD;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,cAAc;EACd,aAAa;EACb,qEAAqE;EACrE,WAAW;AACb;;AAEA,wBAAwB;;AAExB;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;AACpB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;AAC7B;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;AACd;;AAEA,uBAAuB;;AAEvB;EACE,SAAS;EACT,cAAc;EACd,YAAY;EACZ,kEAAkE;AACpE;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA,2BAA2B;;AAE3B;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,QAAQ;AACV;;AAEA,gBAAgB;AAChB;EACE,aAAa;AACf;;AAEA;;EAEE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA,gBAAgB;;AAEhB;EACE,+BAA+B;EAC/B,qDAAqD;EACrD,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,iDAAiD;EACjD,2BAA2B;EAC3B,+DAA+D;AACjE;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;AACZ;;AAEA,iBAAiB;;AAEjB;EACE,6CAA6C;AAC/C","sourcesContent":[".dmn-decision-table-container {\n  --allowed-values-placeholder-color: var(--color-grey-225-10-35);\n  --cell-description-editor-border-color: var(--color-grey-225-10-15);\n  --create-inputs-border-color: var(--color-grey-225-10-75);\n  --create-inputs-color: var(--color-grey-225-10-35);\n  --create-inputs-hover-color: var(--color-grey-225-10-15);\n  --context-menu-background-color: var(--color-white);\n  --context-menu-border-color: var(--color-grey-225-10-75);\n  --context-menu-color: var(--color-grey-225-10-15);\n  --context-menu-box-shadow-color: var(--color-black-opacity-10);\n  --context-menu-group-entry-border-color: var(--color-grey-225-10-75);\n  --context-menu-group-entry-disabled-color: var(--color-grey-225-10-75);\n  --context-menu-group-entry-hover-background-color: var(--color-grey-225-10-95);\n  --drag-and-drop-handle-color: var(--color-grey-225-10-55);\n  --drag-and-drop-handle-hover-color: var(--color-grey-225-10-15);\n  --form-control-label-color: var(--color-grey-225-10-15);\n  --hint-color: var(--color-grey-225-10-15);\n  --edit-button-color: var(--color-grey-225-10-15);\n  --edit-button-background-color: var(--color-grey-225-10-97);\n  --edit-button-border-color: var(--color-grey-225-10-75);\n  --edit-button-box-shadow-color: var(--color-black-opacity-10);\n  --edit-button-disabled-color: var(--color-grey-225-10-75);\n}\n\n/* simple string edit */\n.dmn-decision-table-container .simple-string-edit,\n.dmn-decision-table-container .simple-date-edit {\n  width: 250px;\n}\n\n.dmn-decision-table-container .input-expression-edit {\n  width: 300px;\n}\n\n.dmn-decision-table-container .dms-form-control {\n  padding: 9px 0;\n}\n\n.dmn-decision-table-container .allowed-values-edit .dms-form-control {\n  display: flex;\n  flex-direction: column;\n}\n\n.dmn-decision-table-container .allowed-values-edit .values {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dmn-decision-table-container .allowed-values-edit .placeholder {\n  color: var(--allowed-values-placeholder-color);\n}\n\n/** create inputs **/\n.dmn-decision-table-container thead .input-cell.create-inputs,\n.dmn-decision-table-container tbody .input-cell.create-inputs {\n  white-space: normal;\n  border-color: var(--create-inputs-border-color);\n  color: var(--create-inputs-color);\n  min-width: 50px;\n  width: 50px;\n}\n\n.dmn-decision-table-container thead .input-cell.create-inputs {\n  text-align: center;\n}\n\n.dmn-decision-table-container .create-inputs .add-input {\n  right: 50%;\n}\n\n.dmn-decision-table-container .create-inputs:hover {\n  border-color: var(--create-inputs-hover-color);\n  color: var(--create-inputs-hover-color);\n}\n\n.dmn-decision-table-container th.create-inputs {\n  vertical-align: top;\n}\n\n/** end create inputs **/\n\n/* TODO(nikku): namespace and refactor context menu styles */\n.dmn-decision-table-container .context-menu {\n  position: absolute;\n  background: var(--context-menu-background-color);\n  border: solid 1px var(--context-menu-border-color);\n  border-radius: 2px;\n  font-size: 14px;\n  color: var(--context-menu-color);\n  z-index: 6;\n  box-shadow: 1px 1px 1px 1px var(--context-menu-box-shadow-color);\n}\n\n.dmn-decision-table-container .context-menu .context-menu-container {\n  margin: 8px;\n}\n\n.dmn-decision-table-container .context-menu .context-menu-flex {\n  display: flex;\n  flex-direction: column;\n}\n\n.dmn-decision-table-container .context-menu .context-menu-group .context-menu-group-entry {\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  width: 100%;\n  padding: 8px 16px;\n  cursor: default;\n  white-space: nowrap;\n}\n\n.dmn-decision-table-container .context-menu-group .context-menu-group-entry:hover {\n  background-color: var(--context-menu-group-entry-hover-background-color);\n}\n\n.dmn-decision-table-container .context-menu .context-menu-group .context-menu-group-entry.disabled {\n  pointer-events: none;\n  color: var(--context-menu-group-entry-disabled-color);\n}\n\n.dmn-decision-table-container .context-menu .context-menu-group .context-menu-group-entry .context-menu-group-entry-icon {\n  display: inline-block;\n  text-align: center;\n  width: 14px;\n  margin-right: 6px;\n}\n\n.dmn-decision-table-container .context-menu .context-menu-group .context-menu-group-entry .context-menu-group-entry-icon::before {\n  margin: 0;\n}\n\n.dmn-decision-table-container .context-menu-group:not(:last-child)::after {\n  content: '';\n  display: block;\n  margin: 0 8px;\n  border-bottom: 1px solid var(--context-menu-group-entry-border-color);\n  height: 1px;\n}\n\n/* input/output editor */\n\n.dmn-decision-table-container .context-menu .context-menu-container.input-edit,\n.dmn-decision-table-container .context-menu .context-menu-container.output-edit {\n  margin: 34px 10px 10px;\n}\n\n.dmn-decision-table-container .context-menu .context-menu-container.type-ref-edit,\n.dmn-decision-table-container .context-menu .context-menu-container.allowed-values-edit {\n  margin: 10px;\n}\n\n.dmn-decision-table-container .dms-output-label,\n.dmn-decision-table-container .dms-input-label {\n  padding-right: 30px;\n  padding-left: 0;\n  border: none;\n  font-size: 16px;\n  white-space: nowrap;\n}\n\n.dmn-decision-table-container .dms-form-control:first-child {\n  padding-top: 0;\n}\n\n.dmn-decision-table-container .dms-form-control .dms-label {\n  display: block;\n  margin: unset;\n  margin-bottom: 6px;\n  color: var(--form-control-label-color);\n  font-weight: normal;\n}\n\n.dmn-decision-table-container .dms-form-control .dms-input {\n  padding-right: 24px;\n  border-radius: 3px;\n}\n\n.dmn-decision-table-container .dms-form-control .dms-list-component {\n  max-width: 179px;\n}\n\n/* expression language */\n.dmn-decision-table-container .context-menu .context-menu-group .context-menu-entry-set-expression-language {\n  flex-direction: column;\n}\n\n.dmn-decision-table-container .context-menu .context-menu-group .context-menu-entry-set-expression-language:hover {\n  background-color: unset;\n}\n\n.dmn-decision-table-container .context-menu .context-menu-group .context-menu-entry-set-expression-language .expression-language {\n  margin-top: 8px;\n}\n\n/* drag and drop */\n.dmn-icon-drag {\n  color: transparent;\n}\n\n.dmn-icon-drag:hover {\n  color: var(--drag-and-drop-handle-hover-color);\n}\n\n.dmn-decision-table-container th .dmn-icon-drag {\n  position: absolute;\n  left: 4px;\n  top: 10px;\n  transform: translateY(-50%);\n}\n\n.dmn-decision-table-container th:hover .dmn-icon-drag,\n.dmn-decision-table-container td:hover .dmn-icon-drag {\n  color: var(--drag-and-drop-handle-color);\n}\n\n.dmn-decision-table-container .input-cell.input-editor:hover .clause,\n.dmn-decision-table-container .output-cell.output-editor:hover .clause {\n  visibility: hidden;\n}\n\n.dmn-icon-drag.horizontal,\n.dmn-icon-drag.vertical {\n  cursor: grab;\n}\n\n/* description editor */\n\n.dmn-decision-table-container .context-menu .description-editor {\n  margin: 0;\n  padding: 5px 0;\n  width: 192px;\n  border-left: solid 3px var(--cell-description-editor-border-color);\n}\n\n.dmn-decision-table-container .description-editor .dms-input {\n  border: none;\n  min-height: 0;\n}\n\n/* end description editor */\n\n.dmn-decision-table-container .resize-column-handle {\n  width: 25px;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  right: -5px;\n  z-index: 1;\n  cursor: col-resize;\n}\n\n.dmn-decision-table-container .resize-column-handle:last-child {\n  width: 20px;\n  right: 0;\n}\n\n/* cell editor */\n.dmn-decision-table-container .cell-editor:focus-within .dmn-expression-language {\n  display: none;\n}\n\n.dmn-decision-table-container .cell-editor,\n.dmn-decision-table-container .cell-editor .cm-scroller {\n  line-height: 1.4;\n  font-family: monospace;\n}\n\n.dmn-decision-table-container .cell-editor .feel-editor.focussed > :nth-child(2) {\n  display: none;\n}\n\n/* edit-button */\n\n.dmn-decision-table-container .edit-button {\n  color: var(--edit-button-color);\n  background-color: var(--edit-button-background-color);\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  padding: 4px;\n  border-radius: 2px;\n  border: solid 1px var(--edit-button-border-color);\n  font-size: var(--font-size);\n  box-shadow: 1px 1px 1px 1px var(--edit-button-box-shadow-color);\n}\n\n.dmn-decision-table-container :not(:has(:focus-visible)) .edit-button {\n  clip-path: inset(50%);\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n}\n\n/* context menu */\n\n.dmn-decision-table-container .context-menu-group-entry.focused {\n  background-color: var(--color-grey-225-10-95);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
